import { render, staticRenderFns } from "./Zhuguan.vue?vue&type=template&id=0b25589f&scoped=true"
import script from "./Zhuguan.vue?vue&type=script&lang=js"
export * from "./Zhuguan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b25589f",
  null
  
)

export default component.exports